import { render } from "./FrontView.vue?vue&type=template&id=07bfbfb2"
import script from "./FrontView.vue?vue&type=script&lang=js"
export * from "./FrontView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__